<template>
  <div style="max-height: 300px">
    <video
      v-if="src"
      ref="video"
      width="100%"
      height="100%"
      controls
      playsinline
    ></video>
  </div>
</template>

<style lang="scss">
@import "~plyr/src/sass/plyr.scss";
video {
  max-height: 270px;
}
.plyr:fullscreen video {
  max-height: initial;
}
</style>

<script>
import Hls from "hls.js";
import Plyr from "plyr";

export default {
  name: "HlsPlayer",
  props: {
    src: String
  },
  watch: {
    src: function() {
      this.destroyPlayer();
      this.initPlayer();
    }
  },
  data() {
    return {
      player: {},
      hls: null
    };
  },
  mounted() {
    this.initPlayer();
  },
  beforeDestroy() {
    this.destroyPlayer();
  },
  methods: {
    initPlayer() {
      let video = this.$refs["video"];
      video.addEventListener("pause", () => {
        if (this.hls !== null) {
          this.hls.destroy();
        }
        this.$emit("update:showPlayer", true);
      });

      if (Hls.isSupported()) {
        this.hls = new Hls();
        this.hls.attachMedia(video);

        let load = () => {
          if (this.hls) {
            this.hls.loadSource(this.src);
          }
        };

        this.hls.on(Hls.Events.MEDIA_ATTACHED, function() {
          load();
        });

        this.hls.on(Hls.Events.ERROR, function(e, data) {
          let errorType = data.type;
          switch (errorType) {
            case "networkError":
              setTimeout(load, 4000);
              break;
            default:
              break;
          }
        });

        this.hls.on(Hls.Events.MANIFEST_PARSED, function() {
          video.muted = true;
          video.play();
        });

        this.player = new Plyr(video, {});
      } else {
        video.src = this.src;
        video.play();
      }
    },
    destroyPlayer() {
      if (this.hls) {
        this.hls.destroy();
        this.hls = null;
      }
    }
  }
};
</script>
